/*
 * Anime Pop: "You might also like" row in the cart drawer.
 * <ap-cart-recs> is printed by snippets/header-mini-cart.liquid inside #header-mini-cart-content,
 * so the theme re-renders it on every cart change (add, quantity, remove) and connectedCallback
 * runs again with the new cart. Results are cached per product so re-renders don't flash.
 */
(() => {
  if (customElements.get('ap-cart-recs')) return;

  const cache = new Map();
  const MAX_ITEMS = 4;

  const fetchRecs = (productId, url) => {
    if (!cache.has(productId)) {
      const request = fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .catch((error) => {
          cache.delete(productId);
          throw error;
        });
      cache.set(productId, request);
    }
    return cache.get(productId);
  };

  class ApCartRecs extends HTMLElement {
    connectedCallback() {
      const productId = this.dataset.productId;
      if (!productId) return;
      this.exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${root}recommendations/products?product_id=${productId}&limit=10&intent=related&section_id=ap-cart-recommendations`;
      fetchRecs(productId, url)
        .then((html) => this.render(html))
        .catch(() => this.setAttribute('hidden', ''));
      this.addEventListener('click', this.onClick.bind(this));
    }

    render(html) {
      if (!this.isConnected) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = Array.from(doc.querySelectorAll('.ap-cart-rec'))
        .filter((item) => !this.exclude.has(item.dataset.productId))
        .slice(0, MAX_ITEMS);
      const list = this.querySelector('.ap-cart-recs-list');
      if (!items.length || !list) {
        this.setAttribute('hidden', '');
        return;
      }
      list.replaceChildren(...items.map((item) => document.importNode(item, true)));
      this.removeAttribute('hidden');
    }

    onClick(event) {
      const button = event.target.closest('button[data-variant-id]');
      if (!button || button.classList.contains('loading')) return;
      event.preventDefault();
      const miniCart = window.miniCart || document.querySelector('mini-cart');
      const sections = miniCart && miniCart.getSectionsToRender
        ? [...new Set(miniCart.getSectionsToRender().map((s) => s.section).filter(Boolean))]
        : [];
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(`${addUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (miniCart && miniCart.setError) miniCart.setError(response.description || response.message);
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            return;
          }
          if (miniCart && miniCart.renderContents && response.sections) {
            miniCart.renderContents(response);
          } else if (miniCart && miniCart.updateSectionContents) {
            miniCart.updateSectionContents();
          }
          const items = response.items || [response];
          document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items, context: 'MiniCartRecs' } }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartItemAdd, { source: 'MiniCartRecs', items });
          }
        })
        .catch(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        });
    }
  }

  customElements.define('ap-cart-recs', ApCartRecs);
})();
